/** Opening stock accepts explicit quantities/costs, never blank-as-zero or rounded precision. */
export function parseOpeningQtyHundredths(raw: string | number): number | null {
  const text = String(raw).trim();
  if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return null;
  const value = decimalHundredths(text);
  return value <= 100_000_000 ? value : null;
}

export function parseOpeningCostCents(raw: string): number | null {
  const text = raw.trim().replace(/^\$\s*/, '');
  if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(text)) return null;
  const value = decimalHundredths(text.replace(/,/g, ''));
  return value <= 100_000_000 ? value : null;
}

function decimalHundredths(text: string): number {
  const [whole, fraction = ''] = text.split('.');
  return Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
}
